import { decode } from 'he';

export const decodeHTMLEntities = (htmlEntities: string) => decode(htmlEntities);
